import React, { Component } from "react";

import "react-bootstrap-typeahead/css/Typeahead.css";
import "../stylesheets/FormContainer.scss";

import Input from "./Input";
import Checkbox from "./Checkbox";
import CategorySelect from "./CategorySelect";
import GenderSelect from "./GenderSelect";

class FormContainer extends Component {

    constructor(props){
        super (props);

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleInput = this.handleInput.bind(this);
    }

    test = "";
    endpoint = "https://yellow-api-ng.opendi.com";

    genderOptions = [
        {value: "female", label: "Frau"},
        {value: "male", label: "Herr"},
        {value: "other", label: "Andere"}
    ];
    state = {
        isLoading: false,
        /*formData: {
            companyName: "Opendi AG",
            url: "https://www.opendi.com",
            gender: {value: "male", label: "Herr"},
            addressStreet: "Müllerstr. 40",
            postalCode: "80469",
            addressLocality: "München",
            telephone: "+4915119402162",
            email: "m.feldheim@opendi.com",
            contactName: "Michel Feldheim",
            feedback: null,
            category: '',
        },*/
        formData: {
            companyName: "",
            url: "",
            addressStreet: "",
            postalCode: "",
            addressLocality: "",
            telephone: "",
            email: "",
            gender: "",
            contactName: "",
            feedback: null,
            category: "",
        },
        categorySuggest: {
            isLoading: false,
            options: []
        },
        isSubmitting: false
    };

    render() {

        let checkBoxLabel = <>
            Ich bin damit einverstanden, dass meine Daten, darunter auch solche mit Personenbezug
            (z.B. Name, Telefonnummer usw.), an den Partner von Stadtbranchenbuch.com, die 11880 Internet Services AG, übermittelt werden.
            Die 11880 Internet Services AG wird die Daten nutzen, um ihr Unternehmen auf 11880.com anzuzeigen.
            Diese Einwilligung kann jederzeit widerrufen werden.
        </>;

        return (
            <form onSubmit={this.handleFormSubmit} style={{display: this.props.isVisible ? "block" : "none"}}>

                <Input
                    class="form-control"
                    placeHolder={"Firmenname"}
                    name={"companyName"}
                    icon={"lni-briefcase"}
                    value={this.state.formData.companyName}
                    required={true}
                    handleChange = {this.handleInput}
                />

                <CategorySelect
                    endpoint={this.endpoint}
                    value={this.state.formData.category}
                    onChange={this.handleCategoryChoice}
                />

                <br />

                <Input
                    name={"addressStreet"}
                    placeHolder={"Straße"}
                    icon={"lni-map-marker"}
                    value={this.state.formData.addressStreet}
                    required={true}
                    handleChange = {this.handleInput}
                />

                <div className={"row no-icons"}>

                    <Input
                        name={"postalCode"}
                        placeHolder={"PLZ"}
                        icon={""}
                        value={this.state.formData.postalCode}
                        handleChange ={this.handleInput}
                        multiColumn={true}
                        required={true}
                        pattern={"\\d{5}"}
                        className={"col-4"}
                    />

                    <Input
                        name={"addressLocality"}
                        placeHolder={"Ort"}
                        icon={""}
                        value={this.state.formData.addressLocality}
                        handleChange ={this.handleInput}
                        multiColumn={true}
                        required={true}
                        className={"col-8"}
                    />
                </div>

                <br />

                <Input
                    name={"telephone"}
                    placeHolder={"Telefonnummer"}
                    icon={"lni-phone-handset"}
                    value={this.state.formData.telephone}
                    required={true}
                    pattern={"[0-9- /+()]{6,}"}
                    handleChange ={this.handleInput}
                />

                <Input
                    type="email"
                    name="email"
                    placeHolder={"E-Mail Adresse"}
                    icon={"lni-envelope"}
                    value={this.state.formData.email}
                    required={true}
                    handleChange={this.handleInput}
                />

                <Input
                    name={"url"}
                    placeHolder={"Webseite"}
                    icon={"lni-world"}
                    value={this.state.formData.url}
                    type={"url"}
                    handleChange = {this.handleInput}
                />

                <div className={"row no-icons"}>

                    <div className="form-group col-4">
                        <div className="input-group-prepend"> </div>
                        <GenderSelect
                            value={this.state.formData.gender}
                            options={this.genderOptions}
                            onChange={this.handleGenderChoice}
                        />
                    </div>

                    <Input
                        name={"contactName"}
                        placeHolder={"Ansprechpartner"}
                        icon={""}
                        value={this.state.formData.contactName}
                        handleChange = {this.handleInput}
                        multiColumn={true}
                        required={true}
                        className={"col col-md-8"}
                    />

                </div>

                <Checkbox name={"feedback"}
                          label={checkBoxLabel}
                          handleChange = {this.handleInput}
                          checked = {this.state.formData.feedback}
                          required={true}
                          style={{"font-size": "10px"}}
                />

                <button
                    id="submit"
                    type={"submit"}
                    className="form-control submitButton">
                        kostenlos eintragen
                </button>

            </form>
        )
    }

    handleFormSubmit = (e) => {
        e.preventDefault();

        this.props.showSubmissionMessage();

        let data = this.state.formData;
        data.gender = this.state.formData.gender.value;
        data.category = this.state.formData.category.value;

        console.log("Submitting data to yellow-form-api", JSON.stringify(data));

        fetch(`${this.endpoint}/api/de/listing-form`, {
            method: "POST",
            body: JSON.stringify(this.state.formData),
            headers: {
                "Origin": window.location.origin,
                "Accept": "application/json"
            }}).then(() => {
                this.props.showConfirmationMessage();
            }).catch(() => {
                this.props.showConfirmationMessage();
            });

        this.props.ga.event({
            category: 'Form',
            action: 'Submitted form',
            label: data.companyName + " " + data.addressLocality,
        });
    };


    handleCategoryChoice = (selection) => {
        this.setState( prevState => {
                return {
                    formData : {
                        ...prevState.formData, "category": selection
                    }
                }
            }
        );
    };

    handleGenderChoice = (selection) => {
        this.setState( prevState => {
                return {
                    formData : {
                        ...prevState.formData, "gender": selection
                    }
                }
            }
        );
    };

    handleInput(e) {
        // input field name
        let name = e.target.name;

        // input field value
        let value = e.target.type === "checkbox" ? e.target.checked : e.target.value;


        if (name === "url") {
            if (value.length === 1) {
                if (value === "h") {
                    value = "https://";
                } else {
                    value = "https://" + value;
                }
            }

            if (value.length > 1 && !/^https?:\/\//.test(value)) {
                if ("https://".startsWith(value)) {
                    value = value + "https://".substr(value.length);
                } else if ("http://".startsWith(value)) {
                    value = value + "http://".substr(value.length);
                } else {
                    value = "https://" + value;
                }
            }
        }

        // updating state when field is valid
        this.setState( prevState => {
            return {
                    formData : {
                        ...prevState.formData, [name]: value
                    }
                }
            }
        );
    }
}

export default FormContainer;
